export const PrimaryColor = '#171D1C';
export const SecondaryColor = '#007EA7';
